<app-alert-erro-customizado
  [alertErro]="alertErroImportacao"
  [alertErroMensagem]="mensagemErroImportacao"
  [alertErroTitulo]="tituloMensagemErroImportacao"
  [alertErroBotao]="botaoErroImportacao"
  (alertErroFechou)="fecharAlertErroImportacao()">
</app-alert-erro-customizado>

@if (alertResumoImportacao === true) {
  <div class="body-alert">
    <div class="div-alert text-start mb-5">
      <h5 class="titulo-alert">Resumo de Importação</h5>
      @if (resumoImportacao) {
        <p class="paragrafo">
          Seu arquivo foi carregado com sucesso. Clique em concluir para finalizar o processo.
        </p>
      }
      @if (resumoImportacao === null) {
        <p class="paragrafo">
          Veja os dados referentes ao processo de importação.
        </p>
      }
      @if (showModal == 'AlertLoading') {
        <div class="my-5">
          <app-alert-loading
            [showOverlay]="false"
            [statusUpload]="statusUploadApi"
            [statusFase]="statusFaseApi"
            [alertLoading]="true">
          </app-alert-loading>
        </div>
      }
      <!-- TABELA -->
      @if (resumoImportacao && !showModal) {
        <table
          class="table table-hover border-bottom my-4"
          aria-describedby="tabela que lista resumo da importacao">
          <thead>
            <tr class="border-top border-right-0 border-left-0">
              <th scope="col">CNPJ</th>
              <th scope="col">RAZÃO SOCIAL</th>
              <th scope="col">USUÁRIOS INATIVADOS</th>
              <th scope="col">USUÁRIOS ATUALIZADOS</th>
              <th scope="col">NOVOS USUÁRIOS</th>
            </tr>
          </thead>
          <tbody>
            @for (resumo of resumoImportacao.summaryCompanys; track resumo) {
              <tr>
                <td id="cnpj">{{ resumo.cnpj | cnpj }}</td>
                <td id="nomeEmpresa">{{ resumo.corporateName }}</td>
                <td id="inativados">{{ resumo.usersDelete }}</td>
                <td id="alterados">{{ resumo.usersUpdated }}</td>
                <td id="novos">{{ resumo.usersNew }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (resumoImportacao === false) {
        <div class="row mt-4">
          <div class="col-12">
            <h3 class="titulo-erro">Ocorreu um erro na consulta.</h3>
            <p class="paragrafo">
              Ocorreu um erro ao consultar o resumo da importação.
            </p>
          </div>
        </div>
      }
      @if (resumoImportacao === null) {
        <div class="row mt-4">
          <div class="col-12 text-center">
            <div class="text-center">
              <div class="spinner-border c-primary" aria-hidden="true"></div>
            </div>
            <output class="legenda-spinner">
              Consultando resumo de importação ...
            </output>
          </div>
        </div>
      }
      <!-- Botao CONCLUIR Disabled quando está consultando API ou deu erro na API -->
      @if (showModal == 'AlertLoading' || resumoImportacao === false || resumoImportacao === null) {
        <button
          class="botao-secundario mt-3 disabled"
          disabled
          >
          CONCLUIR
        </button>
      }
      <!-- Botao CONCLUIR Disabled quando não tiver usuários alterados e novos -->
      @if (resumoImportacao && resumoImportacao.canConcludeImportation === false && necessarioBaixarRelatorio === true) {
        <button
          class="botao-secundario mt-3 disabled"
          disabled
          >
          CONCLUIR
        </button>
      }
      <!-- Botao CONCLUIR habilitado quando TIVER usuários alterados ou novos -->
      @if (showModal != 'AlertLoading' && resumoImportacao && resumoImportacao.canConcludeImportation === true) {
        <button
          class="botao-secundario mt-3"
          [ngClass]="{ 'disabled': necessarioBaixarRelatorio === true }"
          (click)="fecharAlertResumoImportacao('concluir')"
          id="concluir"
          [tag]="addTagManagerInteraction('box:button:click', 'concluir')">
          CONCLUIR
        </button>
      }
      <!-- BOTOES CANCELAMENTO DE PEDIDO e Baixar relatório -->
      @if (resumoImportacao || resumoImportacao === false) {
        <button
          class="botao-secundario-outline ms-3 mt-3 ajuste-botao"
          [disabled]="showModal == 'AlertLoading'"
          (click)="fecharAlertResumoImportacao('cancelar')"
          routerLink="/importador-dados"
          id="cancelar"
          [tag]="addTagManagerInteraction('box:button:click', 'cancelar-pedido')">
          CANCELAR PEDIDO
        </button>
      }
      @if (resumoImportacao && resumoImportacao.hasInconsistencies === true) {
        <button
          class="botao-outline ms-3 mt-3"
          (click)="baixarRelatorio()"
          [tag]="addTagManagerInteraction('box:button:click', 'baixar-relatorio-de-inconsistencias')">
          BAIXAR RELATÓRIO DE INCONSISTÊNCIAS
        </button>
      }
      @if (resumoImportacao && resumoImportacao.hasInconsistencies === true) {
        <i
          class="fa fa-info-circle c-black fa-1x ms-2 icone-padrao"
          aria-hidden="true"
          [popover]="myPopoverInconsistencias"
          popoverTitle="Relatório de Inconsistências"
          popoverPlacement="top"
          triggers="click"
          [outsideClick]="true">
        </i>
      }
      <ng-template #myPopoverInconsistencias>
        <span class="texto-tabela">
          Para concluir a importação é necessário baixar o Relatório de Inconsistências.
        </span>
      </ng-template>
    </div>
  </div>
}